exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-wrap{display:flex;flex-direction:column}", ""]);

// exports
